import React from 'react';
import moment from 'moment-timezone';

import { CircleIcon, FontAwesomeIcon } from '@magoosh/lib/icons';
import { pluralize } from 'utilities/pluralize';
import { minutesFormattedasHoursAndMinutesString } from 'utilities/time';

import ScallopedCheck from './assets/scalloped_check.svg';

interface Props {
  createdAt: number;
  name: string;
  nameDetail: string;
  promptCount: number;
  timeInSeconds: number;
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  return (
    <div className="align-items-sm-center d-flex flex-column flex-sm-row gap-s">
      <div className="align-items-center d-flex gap-s">
        <div className="flex-none hidden-xs">
          <img src={ScallopedCheck} alt="" />
        </div>

        <div className="d-flex flex-column">
          <h4 className="u-margin-A-n">
            <strong>{props.name}</strong>
          </h4>

          <div className="small">
            {props.nameDetail}
          </div>
        </div>
      </div>

      <div className="d-flex flex-1 gap-xs justify-content-sm-end small">
        <div>
          {moment(props.createdAt * 1000).tz(timeZone).format('MMMM D')}
        </div>
        
        <div>•</div>

        <div>
          {pluralize(props.promptCount, 'question')}
        </div>
        
        <div>•</div>

        <div>
          {minutesFormattedasHoursAndMinutesString(props.timeInSeconds / 60)}
        </div>
      </div>
    </div>
  );
};
